<template>
  <section v-html="html" />
</template>

<script>
import * as marked from 'marked';

export default {
  name: 'MarkdownText',
  props: {
    md: {
      type: String,
      required: true,
    },
  },
  computed: {
    html() {
      const renderer = new marked.Renderer();
      renderer.image = function renderImage(href, title, text) {
        return `<img src="${href}" alt="${text}" onclick="showLightbox(this)"/>`;
      };
      return marked(this.md || '', { renderer });
    },
  },
};
</script>

<style scoped></style>
